import * as TYPES from './mutationTypes'
const CERTUSE_IBC_SIGN = 3
const CERTUSE_IBC_TLS = 4

function handleData(type, data) {
  let { limit, offset, total } = data
  let items = data.items
  if (type === 'permissionedWithIBC') {
    const dict = {}
    let allKeys = []
    items.forEach(obj => {
      const key = obj.OrgId + '_' + obj.NodeName + '_' + obj.UserName;
      const existingObj = dict[key]
      if (existingObj) {
        // Object.assign(existingObj, obj);
        if (obj.CertUse === CERTUSE_IBC_SIGN) {
          existingObj.Cert3 = obj.Cert
        } else if (obj.CertUse === CERTUSE_IBC_TLS) {
          existingObj.Cert4 = obj.Cert
        }
      } else {
        if (obj.CertUse === CERTUSE_IBC_SIGN) {
          obj.Cert3 = obj.Cert
        } else if (obj.CertUse === CERTUSE_IBC_TLS) {
          obj.Cert4 = obj.Cert
        }
        dict[key] = obj
        allKeys.push(key)
      }
    })
    let newItems = []
    for (const key of allKeys) {
      // 保持数据的顺序不变
      var obj = dict[key]
      newItems.push(obj)
    }
    items = newItems
    limit /= 2
    offset /= 2
    total /= 2
  }
  return { items, limit, offset, total }
}

export default {
  //根证书列表
  [TYPES.GET_ROOT_LIST](state, payload) {
    const { limit, offset, total } = payload.result
    Object.assign(state, {
      root_list: payload.result.items,
      root_paging: { limit, offset, total }
    })
  },
  //组织证书列表
  [TYPES.GET_ORG_LIST](state, payload) {
    const { items, limit, offset, total } = handleData(payload.params.chainMode, payload.result)
    Object.assign(state, {
      // org_list: payload.result.items,
      org_list: items,
      org_paging: { limit, offset, total }
    })
  },
  //节点证书列表
  [TYPES.GET_NODE_LIST](state, payload) {

    const { items, limit, offset, total } = handleData(payload.params.chainMode, payload.result)

    Object.assign(state, {
      // node_list: payload.result.items,
      node_list: items,
      node_paging: { limit, offset, total }
    })
  },
  //用户证书列表
  [TYPES.GET_USER_LIST](state, payload) {
    const { items, limit, offset, total } = handleData(payload.params.chainMode, payload.result)

    Object.assign(state, {
      // user_list: payload.result.items,
      user_list: items,
      user_paging: { limit, offset, total }
    })
  }
}
